import { setShowLoader } from './store/loader';

export { Loader } from './components/Loader';

export const load = <T>(actionFn: () => Promise<T>) => {
  setShowLoader(true);
  return actionFn().finally(() => setShowLoader(false));
};
